import { render, staticRenderFns } from "./WithdrwalSettings.vue?vue&type=template&id=9585b6a4&scoped=true"
import script from "./WithdrwalSettings.vue?vue&type=script&lang=js"
export * from "./WithdrwalSettings.vue?vue&type=script&lang=js"
import style0 from "./WithdrwalSettings.vue?vue&type=style&index=0&id=9585b6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9585b6a4",
  null
  
)

export default component.exports